import { type FC } from 'react'

import {
  type UserDocumentPosition,
  type UserDocumentPositionERx,
} from '@redteclab/api/clients/bully'

import { Checkbox } from 'base-ui'

import {
  OrderImageItem,
  userSubOrderAccessorIsProductErx,
} from '../../../../../order'

type OrderProduct = UserDocumentPosition | UserDocumentPositionERx

export const DirectContactFormOrderProductItemSelection: FC<{
  checked: boolean
  onToggle: () => void
  product: OrderProduct
}> = ({ checked, onToggle, product }) => {
  const isERx = userSubOrderAccessorIsProductErx(product)

  return (
    <label className="flex cursor-pointer items-center gap-4 rounded-m bg-light-primary-low p-4 text-dark-primary-max shadow-m transition-all hover:bg-light-brand-medium hover:shadow-xl">
      <Checkbox
        checked={checked}
        className="shrink-0 cursor-pointer"
        data-qa-id={`direct-contact-checkbox-form-item-${product.pzn}`}
        onChange={onToggle}
      />
      <OrderImageItem
        alt={product.itemName ?? ''}
        data-qa-id={`direct-contact-form-order-item-${product.pzn}`}
        isERx={isERx}
        src={isERx ? undefined : product.thumbnailURL}
      />
      <span className="text-start">{product.itemName}</span>
    </label>
  )
}
